export interface DatasourcePollSyncUpdate {
  readonly id: string;
  readonly sync_status: string;
  readonly sync_status_modified: string;
}

export enum OrganisationDSDisplayStatus {
  NOT_CONNECTED = 'not_connected',
  CONNECTING = 'connecting',
  SYNCING = 'syncing',
  PENDING_SETUP = 'pending_setup',
  SYNC_ERROR = 'sync_error',
  SYNCED = 'synced'
}
